import { useAdministrativeContext } from '../../../../../../../../pages/administrativePanel/administrativePanelContext'
import { useProduct } from '../../../../../../../../services/hooks/useProduct'
import { SpaceLoader } from '../../../../../../../loaders/spaceLoader'
import { Group } from './Group'

import { Container } from './style'


export function GroupsProductsList() {
    const { listBusinessToFilter } = useAdministrativeContext()

    let idBusinessSelectedBusiness = listBusinessToFilter[0]  

    const { data, isLoading } = useProduct(idBusinessSelectedBusiness)
    
   
    return (
        <Container>
            {
                isLoading 
                ?  <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/>
                : 
                data.map(group => (
                    <Group 
                        key={group.idBusiness}
                        group={group}
                    />
                ))
            }
        </Container>
    )
}